import Modal from "src/pages/Modals/ModalBase";
import { useDispatch, useSelector } from "react-redux";
import { reprocessAttachment, setDocUploadfailed } from "src/store/slices/messageSlice";
import { useEffect, useState } from "react";
import { BUTTON_ROLES, BUTTON_TYPES, EVENT_NAMES, EVENT_PARAMETERS, getPageName, MODAL_NAMES } from "src/utils/EventConstants";
import { trackAnalytics } from "src/pages/helpers";
import { isReprocessEndpointAvailable } from "src/utils/attachmentReprocess";
const DocUploadFailedPopup = ({ setReferenceDoc }) => {
  const dispatch = useDispatch();

  const docUploadfailed = useSelector((state) => state.messageSlice.docUploadfailed);
  const userMetadata = useSelector((state) => state.onboarding.userMetadata);
  const threadData = useSelector((state) => state.messageSlice.threadData);
  const failedAttachmentStorageId = useSelector((state) => state.messageSlice.failedAttachmentStorageId);
  const [isRetrying, setIsRetrying] = useState(false);
  // Retry (C-4) is only offered when the reprocess endpoint is available AND we
  // know which storage id failed. Until then the action is hidden entirely.
  const canRetry = isReprocessEndpointAvailable() && Boolean(failedAttachmentStorageId);

  const handleTryAgain = async () => {
    if (isRetrying || !canRetry) return;
    trackAnalytics(
      EVENT_NAMES.CLICKED_BUTTON,
      {
        [EVENT_PARAMETERS.PAGE_NAME]: getPageName(),
        [EVENT_PARAMETERS.THREAD_ID]: threadData?.id,
        [EVENT_PARAMETERS.BUTTON_TYPE]: BUTTON_TYPES.BUTTON_WITH_TEXT,
        [EVENT_PARAMETERS.BUTTON_TEXT]: "Try again",
        [EVENT_PARAMETERS.BUTTON_ROLE]: BUTTON_ROLES.RETRY_ATTACHMENT,
        [EVENT_PARAMETERS.STORAGE_ID]: failedAttachmentStorageId,
        [EVENT_PARAMETERS.CURRENT_PLAN_TIER]: userMetadata?.subscription_type || "anonymous",
        [EVENT_PARAMETERS.USER_ID]: userMetadata?.id,
        [EVENT_PARAMETERS.MODAL_NAME]: MODAL_NAMES.DOCUMENT_UPLOAD_FAILED,
      },
      userMetadata,
    );
    setIsRetrying(true);
    try {
      await dispatch(reprocessAttachment({ storageId: failedAttachmentStorageId }));
      dispatch(setDocUploadfailed(false));
    } finally {
      setIsRetrying(false);
    }
  };
  useEffect(() => {
    if (docUploadfailed) {
      // Event 63:
      trackAnalytics(
        EVENT_NAMES.VIEWED_MODAL,
        {
          [EVENT_PARAMETERS.PAGE_NAME]: getPageName(),
          [EVENT_PARAMETERS.THREAD_ID]: threadData?.id,
          [EVENT_PARAMETERS.CURRENT_PLAN_TIER]: userMetadata?.subscription_type || "anonymous",
          [EVENT_PARAMETERS.USER_ID]: userMetadata?.id,
          [EVENT_PARAMETERS.MODAL_NAME]: MODAL_NAMES.DOCUMENT_UPLOAD_FAILED,
        },
        userMetadata
      );
    }
  }, [docUploadfailed]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Modal
      isOpen={docUploadfailed}
      bodyStyle={{ paddingBottom: "0px", borderRadius: "16px", paddingTop: "0px" }}
      className="w-full md:w-[700px] md:h-full"
    >
      <div className="flex flex-col p-[32px] pb-[40px] gap-[16px] md:gap-[24px] w-full md:w-[800px]">
        <p className="font-sans font-semibold text-[#353535] text-[16px] md:text-[24px]">Document upload failed</p>
        <hr />
        <div className="flex flex-col gap-[12px]">
          <p
            className="font-medium font-sans text-[14px] md:text-[18px] text-[#686868]
"
          >
            There was a problem processing your file. Please try again or use a different file.{" "}
          </p>
          <p className="font-semibold font-sans text-[14px] md:text-[18px] text-[#353535]">
            If the problem persists, please contact our{" "}
            <span className="text-[#3F65A9] underline">support@inhouse.com</span>
          </p>
        </div>
        <div className="flex justify-center md:justify-end mt-6 space-x-4">
          {canRetry && (
            <button
              onClick={handleTryAgain}
              disabled={isRetrying}
              data-testid="doc-upload-retry-button"
              className={`btn-base btn-primary flex justify-center w-full md:w-auto text-[14px] md:text-[16px] ${
                isRetrying ? "cursor-wait opacity-70" : ""
              }`}
            >
              {isRetrying ? "Retrying…" : "Try again"}
            </button>
          )}
          <button
            onClick={() => {
              // Event 64:
              trackAnalytics(
                EVENT_NAMES.CLICKED_BUTTON,
                {
                  [EVENT_PARAMETERS.PAGE_NAME]: getPageName(),
                  [EVENT_PARAMETERS.THREAD_ID]: threadData?.id,
                  [EVENT_PARAMETERS.BUTTON_TYPE]: BUTTON_TYPES.BUTTON_WITH_TEXT,
                  [EVENT_PARAMETERS.BUTTON_TEXT]: "Ok, got it",
                  [EVENT_PARAMETERS.CURRENT_PLAN_TIER]: userMetadata?.subscription_type || "anonymous",
                  [EVENT_PARAMETERS.BUTTON_ROLE]: BUTTON_ROLES.NAVIGATION_CLOSE,
                  [EVENT_PARAMETERS.USER_ID]: userMetadata?.id,
                  [EVENT_PARAMETERS.MODAL_NAME]: MODAL_NAMES.DOCUMENT_UPLOAD_FAILED,
                },
                userMetadata
              );
              dispatch(setDocUploadfailed(false));
              setReferenceDoc(null);
            }}
            className="btn-base btn-secondary flex justify-center w-full md:w-auto  text-[14px] md:text-[16px]"
          >
            Ok, got it
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DocUploadFailedPopup;
